export const Master = {
    categories: [
        {
            id: "1",
            name: 'Bangga Lokal',
            slug: 'bangga-lokal'
        },
        {
            id: "2",
            name: 'Fashion',
            slug: 'fashion'
        },
        {
            id: "3",
            name: 'Food & Beverage',
            slug: 'f-n-b'
        },
        {
            id: "4",
            name: 'Groceries',
            slug: 'groceries'
        },        
        {
            id: "5",
            name: 'Health & Beauty',
            slug: 'health-beauty'
        },
        {
            id: "6",
            name: 'Hobi',
            slug: 'hobi'
        }
    ],
    cities: [
        {
            id: "1",
            name: 'Nasional',
            slug: 'nasional'
        },
        {
            id: "2",
            name: 'Medan',
            slug: 'medan'
        },
        {
            id: "3",
            name: 'Semarang',
            slug: 'semarang'
        },
        {
            id: "4",
            name: 'Batam',
            slug: 'batam'
        },
        {
            id: "5",
            name: 'Jakarta',
            slug: 'jakarta'
        },
        {
            id: "6",
            name: 'Surabaya',
            slug: 'surabaya'
        },
        {
            id: "7",
            name: 'Bali',
            slug: 'bali'
        },
        {
            id: "8",
            name: 'Palembang',
            slug: 'palembang'
        },
        {
            id: "9",
            name: 'Makassar',
            slug: 'makassar'
        },
        {
            id: "10",
            name: 'Bandung',
            slug: 'bandung'
        },
    ],
    "promo": {
        "id": [
            {
                "id": "1",
                "title": "Nakamura Holistic Therapy - Beli 2 Dapat 3 & Diskon 20%",
                "category": "Food & Beverage",
                "periode": "Hingga 31 Desember 2021",
                "link": "https://www.bca.co.id/id/promo-bca/2021/09/06/09/08/nakamura-holistic-therapy",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/09/20210906-Nakamura-Web-Insertion-thumbnail.jpg",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Icon/2021/09/20210906-Nakamura-Web-Insertion-Logo.png"
            },
            {
                "id": "2",
                "title": "Yoshinoya - Potongan Rp15 Ribu Setiap Jumat",
                "category": "Food & Beverage",
                "periode": "10 September – 5 November 2021",
                "link": "https://www.bca.co.id/id/promo-bca/2021/09/06/06/16/Yoshinoya",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/09/20210906-Yoshinoya-thumbnail.jpg",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Icon/2021/09/20210906-Yoshinoya-Logo.jpg"
            },
            {
                "id": "3",
                "title": "Fat Bubble - PAY 1 FOR 2",
                "category": "Food & Beverage",
                "periode": "Hingga 2 September 2022",
                "link": "https://www.bca.co.id/id/promo-bca/2021/09/03/08/02/fat-bubble",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/09/20210903-Fat-bubble-thumb.jpg",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Icon/2021/09/20210903-Fat-bubble-logo.jpg"
            },
            {
                "id": "4",
                "title": "Setiabudhi - Dapatkan e-Voucher Rp50.000",
                "category": "Groceries",
                "periode": "2 September 2021 - 28 Oktober 2021",
                "link": "https://www.bca.co.id/id/promo-bca/2021/09/02/07/23/setiabudhi",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Page/2021/09/20210902-setiabudhi-banner.jpg?v=1",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/09/20210902-setiabudhi-thu.jpg"
            },
            {
                "id": "5",
                "title": "Four Points By Sheraton Batam - Diskon 20%",
                "category": "Food & Beverage",
                "periode": "Hingga 30 Juni 2022",
                "link": "https://www.bca.co.id/id/promo-bca/2021/08/31/03/12/four-points-by-sheraton-batam",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/08/20210831-sheraton-thu.jpg",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Icon/2021/08/20210831-sheraton-logo.jpg"
            },
            {
                "id": "6",
                "title": "Toast Republik - Diskon 25%",
                "category": "Food & Beverage",
                "periode": "23 Agustus 2021 - 31 Agustus 2022",
                "link": "https://www.bca.co.id/id/promo-bca/2021/08/20/09/34/toast-republik",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/08/20210820-Toast-Republik_IMAGE---THUMBNAIL-BCA.jpg",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Icon/2021/08/20210820-Toast-Republik_IMAGE---LOGO-BCA.jpg"
            },
            {
                "id": "7",
                "title": "Bakmitopia - Diskon 20% Setiap Senin-Jumat",
                "category": "Food & Beverage",
                "periode": "Hingga 13 November 2021",
                "link": "https://www.bca.co.id/id/promo-bca/2021/08/19/07/33/bakmitopia",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/08/20210819-Bakmi.jpg",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Icon/2021/08/20210819-Bakmi-logo.jpg"
            },
            {
                "id": "8",
                "title": "Gotcha - Diskon 20%",
                "category": "Food & Beverage",
                "periode": "1 September 2021 - 31 Januari 2022",
                "link": "https://www.bca.co.id/id/promo-bca/2021/08/19/07/26/gotcha",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/08/20210819-gotcha-thu.jpg",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Icon/2021/08/20210819-gotcha-logo.jpg"
            },
            {
                "id": "9",
                "title": "David Black Coffee - Diskon hingga 50%",
                "category": "Food & Beverage",
                "periode": "Hingga 31 Juli 2022",
                "link": "https://www.bca.co.id/id/promo-bca/2021/07/15/07/47/David-Black-Coffee",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/07/20210715-dbc-coffee-thu.jpg",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Icon/2021/07/20210715-dbc-coffee-logo.jpg"
            },
            {
                "id": "10",
                "title": "Sriwijaya - Diskon hingga 12%",
                "category": "Food & Beverage",
                "periode": "Hingga 31 Desember 2021",
                "link": "https://www.bca.co.id/id/promo-bca/2021/05/18/07/51/sriwjaya",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/05/20210518-ASP-sriwijaya-thu.jpg",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Icon/2021/05/20210518-ASP-sriwijaya-logo.jpg"
            },
            {
                "id": "11",
                "title": "Kumulo Concept - Beli 1 Dapat 2 Tiket Masuk",
                "category": "Food & Beverage",
                "periode": "19 April 2021 - 31 Oktober 2021",
                "link": "https://www.bca.co.id/id/promo-bca/2021/04/26/07/03/kumulo-concept",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/04/20210426-ASP-Kumulo-thu.jpg",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Icon/2021/04/20210426-ASP-Kumulo-logo.jpg"
            },
            {
                "id": "12",
                "title": "Grha Eklin Yogyakarta - Diskon hingga 20%",
                "category": "Food & Beverage",
                "periode": "Hingga 31 Desember 2021",
                "link": "https://www.bca.co.id/id/promo-bca/2021/03/30/09/11/grha-eklin-yogyakarta",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/04/Grha-Eklin-Thumbnail-262x152-pixel.jpg"
            },
            {
                "id": "13",
                "title": "PappaJack Asian Cuisine - Diskon 15%",
                "category": "Food & Beverage",
                "periode": "Hingga 31 Desember 2021",
                "link": "https://www.bca.co.id/id/promo-bca/2021/03/05/07/54/pappajack-asian-cuisine",
                "thumbnail": "https://www.bca.co.id/-/media/Images/Promo/2021/umkm/pappajack.jpg?v=1"
            },
            {
                "id": "14",
                "title": "Fore - Diskon hingga 50%",
                "category": "Food & Beverage",
                "periode": "Hingga 3 Desember 2021",
                "link": "https://www.bca.co.id/id/promo-bca/2020/11/06/08/54/fore",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/04/05/20201124-QRIS-Fore-thumbnail.jpg"
            },
            {
                "id": "15",
                "title": "Diskon 50% untuk Item Kedua",
                "category": "Food & Beverage",
                "periode": "13 Agustus 2021 - 31 Desember 2021",
                "link": "https://www.bca.co.id/id/promo-bca/2021/08/09/06/52/ayam-blenger-psp",
                "thumbnail": "https://www.bca.co.id/-/media/Feature/Promo/Thumbnail/2021/08/20210809-ayam-blenger-psp-thumbnail.jpg",
                "logo": "https://www.bca.co.id/-/media/Feature/Promo/Icon/2021/08/20210809-ayam-blenger-psp-logo.jpg"
            }
        ],
        "en": []
    }
}
